import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-access-control',
    template: '<router-outlet></router-outlet>',
})
export class AccessControlComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }
}
